import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 12 10",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M11.536.435a.665.665 0 0 0-.956.038L3.78 8.049 1.419 5.42a.665.665 0 0 0-.955-.038.695.695 0 0 0-.038.963l2.856 3.181a.67.67 0 0 0 .994 0l7.298-8.129a.695.695 0 0 0-.038-.963"
}));
const ForwardRef = forwardRef(SvgComponent);
export const CheckboxCheckmarkIcon = ForwardRef;